import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { withRouter } from "react-router-dom";
import { NavLink } from "react-router-dom";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import LanguageIcon from '@material-ui/icons/Language';
import {useTranslation} from "react-i18next";
import HomeIcon from "@material-ui/icons/Home";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import BusinessIcon from '@material-ui/icons/Business';
import ViewModuleIcon from "@material-ui/icons/ViewModule";
import MobileScreenShareIcon from "@material-ui/icons/MobileScreenShare";
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { AccountCircleOutlined } from "@material-ui/icons";
import MenuIcon from '@material-ui/icons/Menu';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import BuildIcon from '@material-ui/icons/Build';
import {
    AUTHORITY_ADMIN,
    SUPPORTED_LANGUAGES
} from "../constant";
import {validateAuthority} from "../utils/utils";
import {IconButton} from "@material-ui/core";
import AirportShuttleIcon from '@material-ui/icons/AirportShuttle';

const NavigationToolbar = ({ userAuthorities, onLogoutClick, onLanguageChange }) => {
    const { t, i18n } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [displayMobileMenu, setDisplayMobileMenu ] = React.useState(false);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const onIconButtonClick = () => {
        setDisplayMobileMenu(!displayMobileMenu);
    }

    const handleClose = (languageCode) => {
        if (typeof languageCode === 'string') {
            onLanguageChange(languageCode)
        }
        setAnchorEl(null);
    };

    return (
        <AppBar position="static">
            <Toolbar className="toolbar" style={{ background: "white", color: "black"}}>
                <Box display={{ xs: "block", md: "none" }} style={{ float: "right"}}>
                    <MenuItem variant="h7">
                        <IconButton edge="start" color="inherit" aria-label="menu" onClick={() => onIconButtonClick()}>
                            <MenuIcon />
                        </IconButton>
                    </MenuItem>
                </Box>
                <Box className={`${displayMobileMenu ? 'display-block' : 'display-none'} display-desktop-flex`} style={{ float: "right"}}>
                    {
                        SUPPORTED_LANGUAGES.length > 1 && <React.Fragment>
                            <MenuItem variant="h7" onClick={handleClick}>
                                <LanguageIcon />
                                <Box ml={.5}>
                                    <Typography variant="h6" component="h6">
                                        {t(`values.languageCode.${i18n.language}`)}
                                    </Typography>
                                </Box>
                            </MenuItem>
                            <Menu
                                id="fade-menu"
                                anchorEl={anchorEl}
                                keepMounted
                                open={open}
                                onClose={handleClose}
                            >
                                {
                                    SUPPORTED_LANGUAGES.map(supportedLanguage => {
                                        return (
                                            <MenuItem key={supportedLanguage} onClick={() => handleClose(supportedLanguage)}>{t(`values.languageCode.${supportedLanguage}`)}</MenuItem>
                                        )
                                    })
                                }
                            </Menu>
                        </React.Fragment>
                    }
                    <NavLink to="/myAccount" style={{ textDecoration: 'none', color: '#000000' }} className="display-flex" seleniumselector="myAccountTab">
                        <MenuItem variant="h7" component="h6">
                            <AccountCircleOutlined />
                        </MenuItem>
                    </NavLink>
                    <MenuItem variant="h7" onClick={onLogoutClick} seleniumselector="logoutTab">
                        <ExitToAppIcon />
                        <Box ml={.5}>
                            <Typography variant="h6" component="h6">
                                {t('menuItems.logout')}
                            </Typography>
                        </Box>
                    </MenuItem>
                </Box>
            </Toolbar>
        </AppBar>
    )
}

export default withRouter(NavigationToolbar);